import React from "react";
import PropTypes from "prop-types";
import styled, { withTheme } from "styled-components";
import Highstock from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsReact from "highcharts-react-official";

import { H3 } from "commons";

import { ValVsMimoTable } from "./ValVsMimoTable";
import { getConfig } from "../../helpers/ValVsMimoChartHelpers";

HighchartsMore(Highstock);

const getData = analysis => {
    if (!analysis) {
        return null;
    }
    const valKey = Object.keys(analysis.VALUATION_VS_MIMO)[0];
    return analysis.VALUATION_VS_MIMO[valKey];
};

export const hasValidData = (analysis, account) => {
    const valData = getData(analysis);
    return valData && valData.data && valData.data[account];
};

function ValVsMimoComponent({ rangeId, account, selectedAccounts, theme, data, isHome }) {
    const dataFetched = getData(data);
    const chartTitle = isHome ? null : <H3>Valuation vs Payments / Withdrawals</H3>;
    const chartTable = isHome ? null : <ValVsMimoTable account={account} data={dataFetched} />;

    const valVsMimoConfig = getConfig(
        isHome,
        dataFetched,
        account,
        rangeId,
        selectedAccounts,
        theme
    );

    return (
        <Outer>
            {chartTitle}
            <ChartContainer>
                <Chart data-testid="val-vs-mimo-chart-container">
                    <HighchartsReact
                        data-testid="val-vs-mimo-chart"
                        constructorType="stockChart"
                        highcharts={Highstock}
                        options={valVsMimoConfig}
                    />
                </Chart>
            </ChartContainer>
            {chartTable}
        </Outer>
    );
}

const Outer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

const ChartContainer = styled.div`
    display: flex;
    flex-direction: row;
`;

const Chart = styled.div`
    flex: 1 1 auto;
    width: 0;
`;

ValVsMimoComponent.defaultProps = {
    theme: {}
};

ValVsMimoComponent.propTypes = {
    rangeId: PropTypes.string,
    account: PropTypes.string,
    data: PropTypes.object,
    isHome: PropTypes.bool,
    selectedAccounts: PropTypes.object,
    theme: PropTypes.shape({
        primary: PropTypes.string,
        secondary: PropTypes.string,
        tertiary: PropTypes.string
    })
};

export const ValVsMimo = withTheme(ValVsMimoComponent);
